import { dom } from './dom';
import { t } from './i18n';
let pendingDelete = null;
let handlers = null;
export function registerDeleteHandlers(nextHandlers) {
    handlers = nextHandlers;
}
export function openDeleteModal(type, projectId, chatId, label) {
    pendingDelete = { type, projectId, chatId: chatId || undefined, label };
    dom.deleteConfirmTitle.textContent = type === 'project'
        ? t('modals.deleteConfirm.projectTitle')
        : t('modals.deleteConfirm.chatTitle');
    dom.deleteConfirmBody.textContent =
        type === 'project'
            ? t('modals.deleteConfirm.projectBody', { label })
            : t('modals.deleteConfirm.chatBody', { label });
    dom.deleteConfirmModal?.show();
}
export function openByokDeleteModal(entry, providerName) {
    pendingDelete = {
        type: 'byok',
        keyId: entry.id,
        label: `${providerName} key`
    };
    dom.deleteConfirmTitle.textContent = t('modals.deleteConfirm.byokTitle');
    dom.deleteConfirmBody.textContent = t('modals.deleteConfirm.byokBody', {
        provider: providerName,
        suffix: entry.key.slice(-4)
    });
    dom.deleteConfirmModal?.show();
}
export function handleDeleteConfirm() {
    if (!pendingDelete || !handlers) {
        return;
    }
    if (pendingDelete.type === 'project') {
        handlers.onProjectDelete(pendingDelete.projectId);
    }
    else if (pendingDelete.type === 'chat' && pendingDelete.chatId) {
        handlers.onChatDelete(pendingDelete.projectId, pendingDelete.chatId);
    }
    else if (pendingDelete.type === 'byok') {
        handlers.onByokDelete(pendingDelete.keyId);
    }
    pendingDelete = null;
    dom.deleteConfirmModal?.hide();
}
